import { Dialog, DialogBody, DialogHeader } from "@material-tailwind/react"
import { FiX } from "react-icons/fi"

export const PdfPreviewModal = ({ url = "", open = false, handler }) => {

  return (
    <Dialog size='xl' open={open} handler={handler}>
      <DialogHeader className="flex justify-end">
        <FiX className="cursor-pointer" onClick={handler} />
      </DialogHeader>
      <DialogBody>
        <iframe src={url} width="100%" height="780" />
      </DialogBody>
    </Dialog>
  )
}
